import React, { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom';
import { addToCart } from '../../redux/actions/cartActions';
import EmptyCart from './EmptyCart';
import CartItem from './CartItem';
import Bill from './Bill';
import NoAccountCart from './NoAccountCart';
import { UserContext } from '../../Context/ContextProvider';

const Cart = () => {
    const {cartItems}=useSelector(state=>state.cart);
    const {user}=useContext(UserContext);
    // const {id}=useParams();
    const dispatch=useDispatch();
    // useEffect(() => {
        // dispatch(addToCart(id))
    // }, [dispatch])
  return (
    <>
      {
        cartItems.length?
        <div>
          <div className='font-bold text-[30px] my-[12px] text-green-700 text-center my-[20px]'>Total items in cart: {cartItems.length}
          </div>
          <div className='flex flex-col justify-center space-x-[80px] md:flex-row'>
            <div className=''>
              {
                cartItems.map(cartItem=>{
                  return(
                    <CartItem cartItem={cartItem}/>
                  )
                })
              }
                <button className='bg-green-600 px-[80px] py-[10px] rounded-lg shadow-lg my-4 flex items-center justify-end mx-auto text-white'>PLACE ORDER</button>
              </div>
            <Bill cartItems={cartItems}/>
          </div>
          
        </div>
        :
        user?
        <EmptyCart/>:
        <NoAccountCart/>
      }
      
    </>
  )
}

export default Cart
